import { render, staticRenderFns } from "./Registerk.vue?vue&type=template&id=768ae81a&scoped=true&"
import script from "./Registerk.vue?vue&type=script&lang=js&"
export * from "./Registerk.vue?vue&type=script&lang=js&"
import style0 from "./Registerk.vue?vue&type=style&index=0&id=768ae81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ae81a",
  null
  
)

export default component.exports